import { useQuery } from '@tanstack/react-query';

import Client from './client';

import type { UseQueryOptions } from '@tanstack/react-query';

type Response = Awaited<ReturnType<typeof Client.fetchUserMe>>;

const select = (response: Response) => {
  return response?.data?.data;
};
const queryKey = ['me'];

const queryFn = () => {
  return Client.fetchUserMe();
};

export const useUserMe = (
  options: Omit<UseQueryOptions<Response>, 'queryFn' | 'queryKey'> = {},
) => {
  const { data, ...query } = useQuery({
    ...options,
    queryKey,
    queryFn,
    refetchInterval: false,
    refetchOnMount: false,
    select,
    retry: false,
  });

  return { ...query, userMe: data };
};

export const useRefetchUserMe = () => {
  const { refetch } = useUserMe({ enabled: false });

  return refetch;
};
